module.exports = __webpack_public_path__ + "img/horizontal_3_7_pp2_7042.4898dc98.png";